import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../FirebaseConfig.js';
import './loginsignup.css';
import { BsArrowLeft } from 'react-icons/bs';

const Login = () => {
  const history = useNavigate();
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    // Check local storage for rememberMe value on component mount
    const rememberMeValue = localStorage.getItem('rememberMe') === 'true';
    setRememberMe(rememberMeValue);
  
    // Additional check for user ID in local storage (if applicable)
    const userId = localStorage.getItem('userId');
    if (rememberMeValue && userId) {
      history('/diary'); // Redirect if user wants to be remembered and has a user ID
    }
  }, []);
  
  

  const handleBack = () => {
    history('/');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      console.log("User signed in successfully");
      if (rememberMe) {
        localStorage.setItem('userId', userCredential.user.uid); // Store user ID
      } else {
        localStorage.removeItem('userId');
      }
      history('/diary');
    } catch (err) {
      console.error("Error signing in:", err);
      alert(err.code);
    }
  };

  const handleRememberMeChange = () => {
    const newValue = !rememberMe;
    setRememberMe(newValue);
    if (!newValue) {
      localStorage.removeItem('userId');
    }
    localStorage.setItem('rememberMe', newValue);
  };

  return (
    <div className='container'>
      <form onSubmit={handleSubmit}>
        <div className="backButton" onClick={handleBack}>
          <BsArrowLeft /> {/* Render the arrow left icon */}
          Back
        </div>
        <h1>Login</h1>
        <div className="input-box">
          <input name="email" placeholder="Email" required />
        </div>
        <div className="input-box">
          <input name="password" type="password" placeholder='Password' required />
        </div>
        <div className="remember-me">
          <input type="checkbox" id="rememberMe" checked={rememberMe} onChange={handleRememberMeChange} />
          <label htmlFor="rememberMe">Remember Me</label>
        </div>
        <div className='submit'>
          <button type="submit">Login</button>
        </div>
        <div className="register-link">
          <p>Don't have an account? <Link to="/signup">Register</Link></p>
        </div>
      </form>
    </div>
  );
}

export default Login;
